import React from 'react';
import PropTypes from 'prop-types';
import { Box, HelpOutlineIcon, ToolTip, Typography } from '@esgian/esgianui';

function TextWithTooltipIcon({ gap, iconSize, labelVariant, label, tooltipText, styles, tooltipEnterDelayMs }) {
  return (
    <Box sx={{ display: 'flex', gap: gap, alignItems: 'center', ...styles }}>
      {typeof label === 'string' || label instanceof String ? (
        <Typography variant={labelVariant}> {label}</Typography>
      ) : (
        label
      )}
      {tooltipText && <ToolTip title={tooltipText} enterDelay={tooltipEnterDelayMs}>
        <HelpOutlineIcon sx={{ fontSize: iconSize }} />
      </ToolTip>}
    </Box>
  );
}

TextWithTooltipIcon.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconSize: PropTypes.string,
  tooltipEnterDelayMs: PropTypes.number,
  labelVariant: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};

TextWithTooltipIcon.defaultProps = {
  labelVariant: 'subtitle2',
  iconSize: '16px',
  tooltipEnterDelayMs: 100,
  gap: 1
};

export default TextWithTooltipIcon;
